import type {
  ExportBrandingConfigData,
  ExportBrandingResponse,
} from 'src/secret-menu/export-assets/types';
import type { Company } from 'src/secret-menu/hooks/useCompanies';

export type AutoBrandSourceKind = 'pdf' | 'docx';

type AutoBrandDocumentType = 'branded_example' | 'brand_guidelines_pack' | 'unknown';

export type AutoBrandLogoSlot = 'first_page' | 'subsequent_page' | 'footer';

type AutoBrandSlotUpload = {
  file: File | null;
  useCompanyLogo: boolean;
};

type AutoBrandLogoUploads = {
  companyLogo: File | null;
  slots: Record<AutoBrandLogoSlot, AutoBrandSlotUpload>;
};

export type AutoBrandExtractResponse = {
  documentType: AutoBrandDocumentType;
  config: ExportBrandingConfigData;
};

export type AutoBrandTitlePageMode = 'none' | 'template_upload' | 'image_overlay';

export type AutoBrandData = {
  company: Company | null;
  sourceFile: { file: File; kind: AutoBrandSourceKind } | null;
  documentType: AutoBrandDocumentType | null;
  config: ExportBrandingConfigData | null;
  existingBranding: ExportBrandingResponse | null;
  logoUploads: AutoBrandLogoUploads;
  titlePageMode: AutoBrandTitlePageMode;
  titlePageDocx: File | null;
  titlePageImage: File | null;
  titlePagePreparedLocation: string | null;
};

export const initialAutoBrandData: AutoBrandData = {
  company: null,
  sourceFile: null,
  documentType: null,
  config: null,
  existingBranding: null,
  logoUploads: {
    companyLogo: null,
    slots: {
      first_page: { file: null, useCompanyLogo: false },
      subsequent_page: { file: null, useCompanyLogo: false },
      footer: { file: null, useCompanyLogo: false },
    },
  },
  titlePageMode: 'none',
  titlePageDocx: null,
  titlePageImage: null,
  titlePagePreparedLocation: null,
};
